import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LanguageProvider } from '@/context/LanguageContext'
import { ThemeProvider } from '@/context/ThemeContext'
import { WaitlistProvider } from '@/context/WaitlistContext'
import { HomePage } from '@/pages/Home'
import { ThanksPage } from '@/pages/Thanks'
import { EditPage } from '@/pages/Edit'
import { AdminPage } from '@/pages/Admin'

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <WaitlistProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/thanks" element={<ThanksPage />} />
              <Route path="/edit" element={<EditPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </WaitlistProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
